var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-wrap"},[_c('Table',{attrs:{"columns":_vm.columns,"source":_vm.source,"searchParam":_vm.searchParam,"tableType":_vm.tableType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }